<template>
  <div class="grid-cols-3 border-y border-charcoal-100 py-10 lg:grid">
    <p class="order-last col-span-2 text-large-copy md:text-desktop-large-copy">
      "{{ prismic.asText(slice.primary.quote) }}"
    </p>
    <p class="mt-10 text-body-copy lg:mt-0">
      {{ slice.primary.author }}<br />
      {{ slice.primary.role }}<br />
      {{ slice.primary.year }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

const prismic = usePrismic();

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
  getSliceComponentProps<Content.QuoteSlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);
</script>
